import { AppLayout } from 'layouts';
import { Result } from 'ui';

const AuthenticatedNotFound = () => (
  // TODO: Translate
  <AppLayout>
    <Result status="404" subTitle="Page not found" />
  </AppLayout>
);
export default AuthenticatedNotFound;
